"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_OPTIONS = void 0;
Object.defineProperty(exports, "Integrations", {
  enumerable: true,
  get: function () {
    return _tracing.Integrations;
  }
});
exports.default = exports.Sentry = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var Sentry = _interopRequireWildcard(require("@sentry/react"));
exports.Sentry = Sentry;
var _tracing = require("@sentry/tracing");
const _excluded = ["dsn", "release", "environment"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const DEFAULT_OPTIONS = {
  normalizeDepth: 5,
  tracesSampleRate: 0.01,
  autoSessionTracking: true,
  integrations: [new _tracing.Integrations.BrowserTracing()],
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/filtering/#decluttering-sentry
  ignoreErrors: [
  // Random plugins/extensions
  'top.GLOBALS',
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  'originalCreateNotification', 'canvas.contentDocument', 'MyApp_RemoveAllHighlights', 'http://tt.epicplay.com', "Can't find variable: ZiteReader", 'jigsaw is not defined', 'ComboSearch is not defined', 'http://loading.retry.widdit.com/', 'atomicFindClose',
  // Facebook borked
  'fb_xd_fragment',
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
  'bmi_SafeAddOnload', 'EBCallBackMessageReceived',
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  'conduitPage'],
  denyUrls: [
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i, /static\.woopra\.com\/js\/woopra\.js/i,
  // Chrome extensions
  /extensions\//i, /^chrome:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i,
  // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i, /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  // VWO integration
  /dev\.visualwebsiteoptimizer\.com\//i]
};

/**
 * Utilities for working with Sentry. This should be used in conjunction with the <a href="https://github.com/getsentry/sentry-webpack-plugin#usage" target="_blank">Sentry Webpack Plugin</a> to upload sourcemaps to Sentry.
 * @module SentryUtils
 */
exports.DEFAULT_OPTIONS = DEFAULT_OPTIONS;
class SentrySingleton {
  /**
   * Initializes the Sentry SDK. To avoid rate limiting and to ensure that production events get logged properly, only the 'production' environment is supported.
   * @static
   * @function init
   * @param {Object} options - The options to intialize the SDK with.
   * @param {Object} options.dsn - The Sentry DSN.
   * @param {Object} options.release - The release that any events should be associated with. This helps identify when issues began.
   * @param {Object} [options.environment='local'] - The environment that the reports should be associated with. Possible values are 'local', 'integration', 'preprod', and 'production'.
   * @example
   * SentryUtils.init({dsn: 'DSN-HERE', release: 'jenkins-1', environment: 'production', ...});
   * @see {@link https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/|Available Options}
   * @returns {void}
   */
  init(_ref) {
    let {
        dsn,
        release,
        environment = 'local'
      } = _ref,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    const isProd = environment === 'production';
    if (isProd) {
      Sentry.init(_objectSpread(_objectSpread({}, DEFAULT_OPTIONS), {}, {
        dsn,
        release,
        environment
      }, rest));
    }
    SentrySingleton.isProduction = isProd;
  }

  /**
   * Creates a store enhancer for Redux. <strong>NOTE: MAKE SURE NOT TO PASS ANY PII AROUND TO SENTRY!!!</strong>
   * @static
   * @function createReduxEnhancer
   * @param {Object} options - The options to pass to the enhancer.
   * @example
   * SentryUtils.createReduxEnhancer(options);
   * @see {@link https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/redux/|Redux Integration}
   * @returns {Object} - The enhancer to add to the store's compose method.
   */
  createReduxEnhancer(options) {
    if (!SentrySingleton.isProduction) {
      return;
    }
    return Sentry.createReduxEnhancer(options);
  }

  /**
   * Attaches arbitrary data to an event.
   * @static
   * @function setContext
   * @param {String} name - The name of the context.
   * @param {String} context - The data to attach.
   * @example
   * SentryUtils.setContext('foo', {bar: 'baz'});
   * @see {@link https://docs.sentry.io/platforms/javascript/guides/react/enriching-events/context/#structured-context|Structured Context}
   * @returns {void}
   */
  setContext(name, fields) {
    if (!SentrySingleton.isProduction) {
      return;
    }
    Sentry.setContext(name, fields);
  }

  /**
   * Captures exception in Sentry.
   * @static
   * @function captureException
   * @param {Error} error - The exception to send to Sentry.
   * @param {Object|Function} context - Additional context to pass with the exception.
   * @example
   * SentryUtils.captureException(new Error('This is an error.'));
   * @see {@link https://docs.sentry.io/platforms/javascript/guides/react/usage/|Usage}
   * @see {@link https://docs.sentry.io/platforms/javascript/guides/react/enriching-events/context/#passing-context-directly|Passing Context Directly}
   * @returns {void}
   */
  captureException(error, context) {
    if (!SentrySingleton.isProduction) {
      return;
    }
    Sentry.captureException(error, context);
  }

  /**
   * Sends a message to Sentry.
   * @static
   * @function captureMessage
   * @param {String} message - The message to send to Sentry.
   * @param {String} [level='info'] - The log level the message should be recorded as.
   * @example
   * SentryUtils.captureMessage('This is a message.');
   * @see {@link https://docs.sentry.io/platforms/javascript/guides/react/usage/|Usage}
   * @returns {void}
   */
  captureMessage(message) {
    let level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
    if (!SentrySingleton.isProduction) {
      return;
    }
    Sentry.captureMessage(message);
  }

  /**
   * Adds tags (key/value pairs which generate breakdown charts and search filters) in the Sentry UI.
   * @static
   * @function addTags
   * @param {Object} tags - Tags to add to Sentry.
   * @example
   * SentryUtils.addTags({
   *     foo: 'bar',
   *     baz: 'crux'
   * });
   * @returns {void}
   */
  addTags(tags) {
    if (!SentrySingleton.isProduction) {
      return;
    }
    Sentry.configureScope(scope => {
      Object.keys(tags).forEach(tagName => {
        scope.setTag(tagName, tags[tagName]);
      });
    });
  }

  /**
   * Manually adds breadcrumb information.
   * @static
   * @function addBreadcrumbs
   * @param {Array} breadcrumbs - The breadcrumb objects to add.
   * @example
   * SentryUtils.addBreadcrumbs([{
   *     category: 'ui.click',
   *     message: 'The user clicked something!'
   * }]);
   * @see {@link https://docs.sentry.io/platforms/javascript/guides/react/enriching-events/breadcrumbs/#manual-breadcrumbs|Manual Breadcrumbs}
   * @returns {void}
   */
  addBreadcrumbs(breadcrumbs) {
    if (!SentrySingleton.isProduction) {
      return;
    }
    breadcrumbs.forEach(crumb => {
      Sentry.addBreadcrumb(crumb);
    });
  }

  /**
   * Configures the currently active scope.
   * @static
   * @function configureScope
   * @param {Function} cb - The configuration function to call. Will receive a `scope` parameter.
   * @example
   * SentryUtils.configureScope(scope => {
   *     scope.setTag('foo', 'bar');
   *     scope.setLevel('info');
   * });
   * @see {@link https://docs.sentry.io/platforms/javascript/guides/react/enriching-events/scopes/#configuring-the-scope|Configuring the Scope}
   * @returns {void}
   */
  configureScope(cb) {
    if (!SentrySingleton.isProduction) {
      return;
    }
    Sentry.configureScope(cb);
  }

  /**
   * Configures the local scope for the currently running function that does not change the global scope.
   * @static
   * @function withScope
   * @param {Function} cb - The configuration function to call. Will receive a `scope` parameter.
   * @example
   * SentryUtils.withScope(scope => {
   *     scope.setTag('baz', 'crux');
   *     scope.setLevel('warning');
   *     SentryUtils.captureException(new Error('This is an error.'));
   * });
   * @see {@link https://docs.sentry.io/platforms/javascript/guides/react/enriching-events/scopes/#local-scopes|Local Scopes}
   * @returns {void}
   */
  withScope(cb) {
    if (!SentrySingleton.isProduction) {
      return;
    }
    Sentry.withScope(cb);
  }
}
(0, _defineProperty2.default)(SentrySingleton, "isProduction", false);
const SentryUtils = new SentrySingleton();
Object.freeze(SentryUtils);
var _default = SentryUtils;
exports.default = _default;